module.exports = __webpack_public_path__ + "img/vi.f36067e6.svg";